const RESET_LOCATION_INPUT = 'classpass/LocationInput/RESET_LOCATION_INPUT';
const SET_INPUT_LOCATION = 'classpass/LocationInput/SET_INPUT_LOCATION';
const SET_INPUT_SELECTION = 'classpass/LocationInput/SET_INPUT_SELECTION';
const SET_PLACE_QUERY = 'classpass/LocationInput/SET_PLACE_QUERY';

export const resetLocationInput = () => ({ type: RESET_LOCATION_INPUT, data: { key: 'selection', value: null } });
export const setInputLocation = ({ lat, lon, name } = {}) => ({
  type: SET_INPUT_LOCATION,
  data: { key: 'location', value: { lat, lon, name } },
});
export const setInputSelection = selection => ({
  type: SET_INPUT_SELECTION,
  data: { key: 'selection', value: selection },
});
export const setPlaceQuery = query => ({ type: SET_PLACE_QUERY, data: { key: 'query', value: query } });

export const selectInputLocation = state => state.features.locationInput.location;
export const selectInputSelection = state => state.features.locationInput.selection;
export const selectPlaceQuery = state => state.features.locationInput.query;

const initialState = {
  location: null,
  query: '',
  selection: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_INPUT_LOCATION:
    case SET_INPUT_SELECTION:
    case SET_PLACE_QUERY:
      return { ...state, [action.data.key]: action.data.value };
    case RESET_LOCATION_INPUT:
      return initialState;
    default:
      return state;
  }
}
